// global
import { push } from 'react-router-redux';
// local
// actions
import { pending, rejected, fulfilled } from '../async';
import dispatchError from '../error';
import { showSnackbar } from '../snackbar';
// api
import * as Delivery from 'app/api/delivery';

const ACTION_KEY = 'CONFIRM_DELIVERY';

export function sort(date, column, direction) {
    return {
        type: `${ACTION_KEY}_SORT`,
        payload: { date, column, direction },
    };
}

export function updateCylinderQtd(date, patientId, counter) {
    return {
        type: `${ACTION_KEY}_MARK_SAVED`,
        payload: { date, patientId, counter },
    };
}

export function listConfirmDelivery() {
    return dispatch => {
        dispatch(pending(ACTION_KEY));
        Delivery.listConfirmDelivery()
            .then(payload => dispatch(fulfilled(ACTION_KEY, payload)))
            .catch(err => {
                dispatch(rejected(ACTION_KEY, err));
                dispatchError(dispatch, err);
            });
    };
}

export function confirmPendingDelivery(replacements) {
    return dispatch => {
        dispatch(pending(ACTION_KEY));
        Delivery.confirmPendingDelivery({ replacements })
            .then(() => {
                dispatch(showSnackbar({ title: 'Entrega(s) confirmada(s) com sucesso!', action: true }));
                dispatch(listConfirmDelivery());
            })
            .catch(err => {
                dispatch(rejected(ACTION_KEY, err));
                dispatchError(dispatch, err);
            });
    };
}

export function resetPendingDelivery() {
    return {
        type: `${ACTION_KEY}_RESET`,
    };
}

export function updateEdit(date, patientId, isEdit) {
    return {
        type: `${ACTION_KEY}_UPDATE_EDIT`,
        payload: { date, patientId, isEdit },
    };
}

export function updateValue(date, patientId, value, hasChanged) {
    return {
        type: `${ACTION_KEY}_UPDATE_VALUE`,
        payload: { date, patientId, value, hasChanged },
    };
}

export function openEdit() {
    return push('/edit-confirm-delivery');
}

export function openConfirmPopup() {}
